import { FaTimes, FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import AddItem from "./AddItem";

const StudentListTable = ({className, semesterName, studentList, removeStudent, setChecks, checkedStudents, addStudent}) => {
    const navigate = useNavigate();
    return (
        <table className="table table-striped table-hover table-bordered">
                <thead className="table-dark">
                    <tr>
                        <th>
                            <div className="row">
                                <div className="col-auto">Students of {className} of {semesterName}</div>
                                <div className="col text-end">Count: {studentList.length}</div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {studentList.map((student,index) =>{
                        return (
                            <tr key={student.id}>
                                <td>
                                    <div className="row">
                                        
                                        <div 
                                            style={{cursor:"pointer"}}
                                            onClick={() =>{
                                                navigate(`/student-details/${student.id}`)
                                            }} 
                                            onContextMenu={(e)=>{
                                                e.preventDefault();
                                                setChecks(checkedStudents.map((check, dex) =>{
                                                    if(dex === index){
                                                        return !check;
                                                    }
                                                    return check;
                                                }))
                                            }} className="col-6"
                                        >
                                            {checkedStudents[index] ? (<FaRegCheckSquare className="pe-1"/>): checkedStudents.includes(true) && (<FaRegSquare className="pe-1"/>)}
                                            {student.name} 
                                        </div>
                                        <div className="col-5">Check-In Count: {student.attendance ? student.attendance.length: 0}</div>
                                        <div className="col-1 text-center"><FaTimes style={{cursor:"pointer"}} onClick={()=>{removeStudent(student.id)}}/></div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                    {studentList.length === 0 && (
                        <tr>
                            <td>No Students found</td>
                        </tr>
                    )}
                    <tr>
                        <td>
                            <AddItem title='Add Student' prompts={[{prompt:"Student Name",varName:"name"},{prompt:"Student Email",varName:"email"}]} addItem={addStudent}/>
                        </td>
                    </tr>
                </tbody>
            </table>
    )
}

export default StudentListTable